"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _core2 = require("@stt-componentes/core");
var _SttCard = _interopRequireDefault(require("./SttCard"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    root: {
      flexGrow: 1
    },
    verMaisContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: theme.spacing(2),
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(2)
    },
    verMaisButton: {
      textTransform: "none",
      fontWeight: 600,
      padding: theme.spacing(1.5, 4),
      borderRadius: "8px"
    }
  };
});
var SttCardContainer = function SttCardContainer(_ref) {
  var cursos = _ref.cursos,
    _acessar = _ref.acessar,
    visualizar = _ref.visualizar,
    naoComplementados = _ref.naoComplementados,
    onFavoritar = _ref.onFavoritar,
    fileirasIniciais = _ref.fileirasIniciais,
    fileirasCarregar = _ref.fileirasCarregar,
    count = _ref.count,
    page = _ref.page,
    totalRegistros = _ref.totalRegistros,
    onRowsPerPageChange = _ref.onRowsPerPageChange,
    strings = _ref.strings;
  var classes = useStyles();
  var _useState = (0, _react.useState)(4),
    _useState2 = _slicedToArray(_useState, 2),
    cartoesPorLinha = _useState2[0],
    setCartoesPorLinha = _useState2[1];
  var _useState3 = (0, _react.useState)(fileirasIniciais),
    _useState4 = _slicedToArray(_useState3, 2),
    fileirasVisiveis = _useState4[0],
    setFileirasVisiveis = _useState4[1];
  (0, _react.useEffect)(function () {
    var aoRedimensionar = function aoRedimensionar() {
      var largura = window.innerWidth;
      if (largura < 600) {
        setCartoesPorLinha(1);
      } else if (largura < 960) {
        setCartoesPorLinha(2);
      } else if (largura < 1280) {
        setCartoesPorLinha(3);
      } else {
        setCartoesPorLinha(4);
      }
    };
    aoRedimensionar();
    window.addEventListener("resize", aoRedimensionar);
    return function () {
      return window.removeEventListener("resize", aoRedimensionar);
    };
  }, []);
  if (!cursos || cursos.length === 0) {
    return null;
  }
  var totalCarregados = (page + 1) * count;
  var temMaisCursosBackend = totalCarregados < totalRegistros;
  var fileirasAtuais = Math.ceil(cursos.length / cartoesPorLinha);
  var podeMostrarMenos = fileirasVisiveis > fileirasIniciais;
  var fileirasParaMostrar = Math.min(fileirasVisiveis, fileirasAtuais);
  var cartoesVisiveis = fileirasParaMostrar * cartoesPorLinha;
  var cursosExibidos = cursos.slice(0, cartoesVisiveis);
  var temCursosOcultos = cursos.length > cursosExibidos.length;
  var temMaisCursos = temCursosOcultos || temMaisCursosBackend;
  var carregarMais = function carregarMais() {
    var novasFileiras = fileirasVisiveis + fileirasCarregar;
    var cartoesNecessarios = novasFileiras * cartoesPorLinha;
    if (cartoesNecessarios > cursos.length && temMaisCursosBackend) {
      var novoCount = Math.ceil(cartoesNecessarios / cartoesPorLinha) * cartoesPorLinha;
      if (onRowsPerPageChange) {
        onRowsPerPageChange({
          target: {
            value: novoCount
          }
        });
      }
    }
    setFileirasVisiveis(novasFileiras);
  };
  var verMenos = function verMenos() {
    var novasFileiras = Math.max(fileirasIniciais, fileirasVisiveis - fileirasCarregar);
    setFileirasVisiveis(novasFileiras);
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react["default"].createElement(_core2.SttGrid, {
    container: true,
    spacing: 2
  }, cursosExibidos.map(function (curso, index) {
    return /*#__PURE__*/_react["default"].createElement(_core2.SttGrid, {
      item: true,
      xs: 12,
      sm: 6,
      md: 4,
      lg: 3,
      xl: 3,
      key: curso.id
    }, /*#__PURE__*/_react["default"].createElement(_SttCard["default"], {
      id: curso.id,
      index: index,
      turma: curso.turma,
      url: curso.url,
      titulo: curso.titulo,
      conteudo_arquivo: curso.conteudo_arquivo,
      dataInicio: curso.data_inicio,
      dataFim: curso.data_fim,
      instituicao: curso.instituicao,
      acessar: function acessar() {
        return _acessar(curso.url);
      },
      visualizar: visualizar,
      naoComplementados: naoComplementados,
      situacaoCurso: curso.situacaoCurso,
      situacaoInscricao: curso.situacaoInscricao,
      tenho_interesse: curso.tenho_interesse,
      onFavoritar: onFavoritar
    }));
  })), (temMaisCursos || podeMostrarMenos) && /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.verMaisContainer
  }, podeMostrarMenos && /*#__PURE__*/_react["default"].createElement(_core2.SttButton, {
    variant: "outlined",
    color: "primary",
    className: classes.verMaisButton,
    onClick: verMenos
  }, strings.verMenos), temMaisCursos && /*#__PURE__*/_react["default"].createElement(_core2.SttButton, {
    variant: "contained",
    color: "primary",
    className: classes.verMaisButton,
    onClick: carregarMais
  }, strings.verMais)));
};
var _default = SttCardContainer;
exports["default"] = _default;